/**
 * Created by x10668 on 2017/3/30.
 */
import Vue from 'vue'
const API_BASE_URI = window.globalConfig.apiUri
const API_PATH_FORWARD = window.globalConfig.forward
const API_HOST_URI = window.globalConfig.apiHostUri
const API_RCA_URI = window.globalConfig.rcaUri

const SWITCH = window.globalConfig.switch //true为打开鉴权//

const GET_ASSOCIATE_WORD = window.globalConfig.getAssociateWord
const FEEDBACK = window.globalConfig.feedbackComplaint
const GET_SERIES_BY_SEGMENT = window.globalConfig.getSeriesBySegment
const GET_MODELS_BY_SEGMENT = window.globalConfig.getModelsBySegment
const GET_VERSIONS_BY_SEGMENT = window.globalConfig.getVersionsBySegment
const GET_RESOURCE_BY_ID = window.globalConfig.getResourceById
const ISERVICE_FULL_TEXT = window.globalConfig.iserviceFullText
const CHANNEL_FULL_TEXT = window.globalConfig.channelFullText
const DMP_FULL_TEXT = window.globalConfig.dmpFullText


const GET_RELEASE_NOTES_BY_ID = window.globalConfig.getReleaseNotesById
const GET_RELEASE_CONTENT_BY_ID = window.globalConfig.getReleaseContentById
const GET_RELEASE_ISSUES = window.globalConfig.getReleaseIssues
const GET_NEWER_VERSIONS = window.globalConfig.getNewerVersions
const TREE = window.globalConfig.tree
const ALIGNMENT_VERSION = window.globalConfig.alignmentVersion

Vue.prototype.$switch = SWITCH
Vue.prototype.$apiPrifixUri = API_BASE_URI
Vue.prototype.$apiPathPrifix = API_PATH_FORWARD
Vue.prototype.$apiPrifixHostUri = API_HOST_URI
Vue.prototype.$globalAppConfig = window.globalConfig
Vue.prototype.$socketUri = window.globalConfig.socketUrl
Vue.prototype.$rcaUri = API_RCA_URI

Vue.prototype.$associateSearchWordPath = GET_ASSOCIATE_WORD
Vue.prototype.$feedbacPath = FEEDBACK
Vue.prototype.$getSeriesBySegmentPath = GET_SERIES_BY_SEGMENT
Vue.prototype.$getModelsBySegmentPath = GET_MODELS_BY_SEGMENT
Vue.prototype.$getVersionsBySegmentPath = GET_VERSIONS_BY_SEGMENT
Vue.prototype.$getResourceByIdPath = GET_RESOURCE_BY_ID
Vue.prototype.$channelFullTextPath = CHANNEL_FULL_TEXT
Vue.prototype.$dmpFullTextPath = DMP_FULL_TEXT
Vue.prototype.$iserviceFullTextPath = ISERVICE_FULL_TEXT
// ISERVICE_FULL_TEXT
Vue.prototype.$getReleaseNotesByIdPath = GET_RELEASE_NOTES_BY_ID
Vue.prototype.$getReleaseContentByIdPath = GET_RELEASE_CONTENT_BY_ID
Vue.prototype.$getReleaseIssuesPath = GET_RELEASE_ISSUES
Vue.prototype.$getNewerVersionsPath = GET_NEWER_VERSIONS
Vue.prototype.$treePath = TREE
Vue.prototype.$alignmentVersionPath = ALIGNMENT_VERSION

var config = {
  API_BASE_URI: API_BASE_URI,
  APP_CONFIG: window.globalConfig,
  SWITCH:SWITCH
}
console.log('config',config)
export default config



// WEBPACK FOOTER //
// ./src/config/config.js